import {useState} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators, compose} from 'redux';
import {withRouter} from 'react-router';
import get from 'lodash/get';
import {DeprecatedButton} from 'shipwell-ui';
import {generateBOL, generateRateConfirmation} from 'App/actions/documents';
import {trackClickGenerateDocument} from 'App/utils/analytics';
import withStatusToasts from 'App/components/withStatusToasts';
import {
  UPDATE_SHIPMENTS_USER_PERMISSION,
  UPDATE_MY_SHIPMENTS_USER_PERMISSION
} from 'App/components/permissions/PermissionsFallback/constants';

export const GENERATE_BOL = 'BOL';
export const GENERATE_RATE_CONFIRMATION = 'Rate Confirmation';

const GenerateDocAction = ({
  shipment,
  toGenerate,
  generateBOL,
  generateRateConfirmation,
  router,
  canEdit,
  setError
}) => {
  const [generatingDoc, setGeneratingDoc] = useState(false);

  const handleGenerateDocClick = async () => {
    setGeneratingDoc(true);
    trackClickGenerateDocument(toGenerate === GENERATE_RATE_CONFIRMATION ? 'Rate  Con' : 'BOL');
    try {
      const generateDocMethod = toGenerate === GENERATE_BOL ? generateBOL : generateRateConfirmation;
      const response = await generateDocMethod(shipment.id);
      router.push(`/shipments/${shipment.id}/documents/${response.details.id}`);
    } catch (e) {
      const message = `Error generating ${toGenerate} for ${shipment.id}`;
      console.error(message, e);
      setError(message);
      setGeneratingDoc(false);
    }
  };

  return (
    <DeprecatedButton disabled={generatingDoc || !canEdit} variant="text" onClick={handleGenerateDocClick}>
      {`Generate ${toGenerate}`}
    </DeprecatedButton>
  );
};

GenerateDocAction.propTypes = {
  shipment: PropTypes.object,
  toGenerate: PropTypes.oneOf([GENERATE_BOL, GENERATE_RATE_CONFIRMATION]).isRequired,
  generateBOL: PropTypes.func,
  generateRateConfirmation: PropTypes.func,
  router: PropTypes.object,
  canEdit: PropTypes.bool
};

GenerateDocAction.defaultProps = {
  shipment: {},
  generateBOL: () => {},
  generateRateConfirmation: () => {},
  router: {},
  canEdit: false
};

export default compose(
  withStatusToasts,
  withRouter,
  connect(
    (state) => ({
      canEdit:
        get(state, 'userProfile.user.permissions', []).includes(UPDATE_SHIPMENTS_USER_PERMISSION) ||
        get(state, 'userProfile.user.permissions', []).includes(UPDATE_MY_SHIPMENTS_USER_PERMISSION)
    }),
    (dispatch) => bindActionCreators({generateBOL, generateRateConfirmation}, dispatch)
  )
)(GenerateDocAction);
